import JsonApiObject from '@/_models/JsonApi'

export default class ContractorModel extends JsonApiObject {
    constructor(data: any, included?: any) {
        super(data, included)
    }

    get company() {
        return this._relationships['company']
    }

    get name() {
        const namePath = this['namePath']
        if (Array.isArray(namePath)) {
            return namePath[namePath.length - 1]
        }
        return ''
    }
}
